import React, { useCallback } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { isEmpty, isNil } from 'ramda'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, withStyles } from '@material-ui/core'

import PlainText from 'app/componentV4/PlainText'
import LightTooltip from 'app/componentV4/Tooltip/LightTooltip'
import MessageType from 'app/componentV4/MessageDetail/MessageType'
import EventBadge from 'app/componentV4/MessageDetail/Event/EventBadge'

import Badges from 'app/main/messages/timeline/components/Badges'
import PreviewBody from 'app/main/messages/timeline/components/PreviewBody'

const useStyles = makeStyles({
  root: {
    width: '25vw',
    minWidth: '180px',
  },
  title: {
    'line-clamp': 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  body: {
    'line-clamp': 3,
    overflow: 'hidden',
    display: '-webkit-box',
    textOverflow: 'ellipsis',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
  },
})

const CustomLightTooltip = withStyles({
  tooltip: {
    width: '350px',
  },
})(LightTooltip)

const TitlePreview = (props) => {
  const { data = {} } = props
  const classes = useStyles()

  const RenderEmpty = () => {
    return (
      <Typography className={'text-14 text-neutrals-600 font-normal'}>
        -
      </Typography>
    )
  }

  const renderTitle = useCallback(() => {
    return (
      <div className={clsx(classes.root, 'cursor-pointer')}>
        {isEmpty(data.translation.title) ? (
          <div className="flex space-x-3 items-center">
            <MessageType
              type={data.type}
              isReminder={data.isReminder}
              fill="#A3A3A3"
            />
            <RenderEmpty />
          </div>
        ) : (
          <div className="flex space-x-3 items-center">
            <MessageType
              type={data.type}
              isReminder={data.isReminder}
              fill="#A3A3A3"
            />
            {data.isDraft ? null : (
              <>
                {/* isScheduled */}
                {data.isScheduled ? (
                  <Badges
                    isCanceleScheduled={
                      data.isScheduled && !isNil(data.scheduleCanceledDate)
                    }
                    date={data.scheduleDate}
                  />
                ) : null}
                {isNil(data.event) ? null : (
                  <EventBadge status={data.event.status} />
                )}
                {/* expirationDate */}
                {data.expirationDate ? (
                  <Badges isExpiration={true} date={data.expirationDate} />
                ) : null}
                {/* poll */}
                {isNil(data.poll) ? null : (
                  <Badges isPoll={true} poll={data.poll} />
                )}
              </>
            )}
            <Typography className="text-16 text-neutrals-600 font-normal truncate">
              <PlainText text={data.translation.title} />
            </Typography>
          </div>
        )}
      </div>
    )
  }, [classes, data])

  return (
    <CustomLightTooltip
      placement="bottom-start"
      title={<PreviewBody data={data} className="p-5 space-y-5" />}
    >
      {renderTitle()}
    </CustomLightTooltip>
  )
}

const dataPropTypes = {
  id: PropTypes.number,
  type: PropTypes.number,
  scope: PropTypes.number,
  level: PropTypes.number,
  isScheduled: PropTypes.bool,
  isDraft: PropTypes.bool,
  isReminder: PropTypes.bool,
  translation: PropTypes.shape({
    title: PropTypes.string,
    descriptionPreview: PropTypes.string,
    body: PropTypes.string,
    languageId: PropTypes.number,
    languageCode: PropTypes.string,
  }),
  scheduleCanceledDate: PropTypes.string,
  expirationDate: PropTypes.string,
  defaultImageType: PropTypes.string,
  event: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    startTimeZone: PropTypes.string,
    endTimeZone: PropTypes.string,
    status: PropTypes.number,
  }),
  poll: PropTypes.shape({
    id: PropTypes.number,
    status: PropTypes.string,
  }),
}
TitlePreview.propTypes = {
  data: PropTypes.shape(dataPropTypes).isRequired,
}

export default TitlePreview
